// extracted by mini-css-extract-plugin
export default {"card":"form_card__4eKKM","cardTitle":"form_cardTitle__TxQFq","sideTitle":"form_sideTitle__m1PZX","label":"form_label__PR+dh","value":"form_value__2TLN5"};